import * as React from 'react'

import { PrimaryButton } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'
import { useActivatePhysicalCardButtonPresenter } from './useActivatePhysicalCardButtonPresenter'

export interface ActivatePhysicalCardButtonPresenterProps {
  externalId: string
  onCardActivated: () => void
}

export const ActivatePhysicalCardButtonPresenter = ({
  externalId,
  onCardActivated,
}: ActivatePhysicalCardButtonPresenterProps) => {
  const intl = useProcurifyIntl()

  const {
    commands: { openActivateCardFormModal },
  } = useActivatePhysicalCardButtonPresenter()

  return (
    <PrimaryButton
      fullWidth
      onClick={() =>
        openActivateCardFormModal({
          externalId,
          onCardActivated,
        })
      }
    >
      {intl.formatMessage(messages.activateCardButtonText)}
    </PrimaryButton>
  )
}
